var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconawesomeMapMarked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.5,
    height: 36,
    viewBox: "0 0 40.5 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-map-marked",
    "data-name": "Icon awesome-map-marked",
    d: "M20.25,0a8.859,8.859,0,0,0-8.859,8.859c0,3.956,5.79,11.166,8.009,13.783a1.109,1.109,0,0,0,1.7,0c2.218-2.617,8.009-9.827,8.009-13.783A8.859,8.859,0,0,0,20.25,0ZM1.415,15.184A2.25,2.25,0,0,0,0,17.273v17.6a1.125,1.125,0,0,0,1.543,1.045L11.25,31.5V15.112a21.293,21.293,0,0,1-1.494-3.264ZM20.25,25.289A3.36,3.36,0,0,1,17.683,24.1C16.3,22.466,14.83,20.608,13.5,18.7V31.5L27,36V18.7c-1.33,1.9-2.8,3.763-4.183,5.394A3.361,3.361,0,0,1,20.25,25.289ZM38.957,11.332,29.25,15.75V36l9.835-3.934A2.25,2.25,0,0,0,40.5,29.977v-17.6A1.125,1.125,0,0,0,38.957,11.332Z",
    fill: "#e8e3d8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeMapMarked);
export default __webpack_public_path__ + "static/media/Icon awesome-map-marked.a25693073235b85d4ead7414c16395f9.svg";
export { ForwardRef as ReactComponent };